import getScrollBarSize from './getScrollBarSize';

export default (function (close) {
  var bodyIsOverflowing = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
  if (!bodyIsOverflowing) {
    return;
  }
  if (close) {
    document.body.style.position = '';
    document.body.style.width = '';
    return;
  }
  var scrollBarSize = getScrollBarSize();
  if (scrollBarSize) {
    document.body.style.position = 'relative';
    document.body.style.width = 'calc(100% - ' + scrollBarSize + 'px)';
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.3@ant-design-vue/es/_util/switchScrollingEffect.js
// module id = null
// module chunks = 